import { Loading } from 'vnetwork-ui'

interface LoadingBoxProps {
    color?: string
}

const LoadingBox: React.FC<LoadingBoxProps> = ({ color }) => {
    return (
        <div className="p-4">
            <Loading.CircularProgress width={20} height={20} color={color} />
        </div>
    )
}

export default LoadingBox
